<template>
  <div class="col s12 logbook-page">
    <div class="row">
      <div class="col s12">
        <div class="section no-padding">
          <h5>Axlecounter</h5>
          <p>Logbook</p>
        </div>
        <div class="divider"></div>
      </div>
    </div>
    <div class="row" v-show="AddNewEntry">
      <div class="col s12">

        <div class="row">
          <div class="col s1">Comment</div>
          <input class="col s3" type="text" v-model="NewEntry.Comment">
        </div>

      </div>
    </div>
    <div class="row" v-show="!AddNewEntry">
      <div class="col s12">
        <p v-show="LogbookItems.length === 0">No logs available</p>
        <table class="striped" v-show="LogbookItems.length !== 0">
          <thead>
            <tr>
              <th>Date</th>
              <th>Author</th>
              <th>Comment</th>
              <th>Type</th>
            </tr>
          </thead>

          <tbody>
            <tr v-for="(item, index) in LogbookItems" v-bind:key="index"
              v-show="index + 1 <= (paging.itemsPerPage * paging.selectedPage) &&
              index + 1 > ((paging.itemsPerPage * paging.selectedPage) -paging.itemsPerPage)">
              <td>{{ formatDateTime(item.CommentDateTime) }}</td>
              <td>{{ item.UserName }}</td>
              <td>{{ item.Comment }}</td>
              <td>{{ $t(commentTypeToText(item.CommentTypeId)) }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="row" v-show="!AddNewEntry">
      <div class="col s12">
        <ul class="pagination center-align" v-if="paging.enabled && LogbookItems.length > 0">
          <li
            :class="{ disabled: paging.selectedPage === 1, 'waves-effect': paging.selectedPage > 1 }"
            @click="paging.selectedPage !== 1 && paging.selectedPage--">
            <i class="material-icons">chevron_left</i>
          </li>

          <li
            v-for="(pageNumber, index) in paging.numberOfPages" v-bind:key="index"
            class="waves-effect"
            :class="{ active: paging.selectedPage == pageNumber }"
            @click="paging.selectedPage = pageNumber"
          >
            <a>{{ pageNumber }}</a>
          </li>

          <li :class="{ disabled: paging.selectedPage === paging.numberOfPages, 'waves-effect': paging.selectedPage < paging.numberOfPages }"
            @click="paging.selectedPage !== paging.numberOfPages && paging.selectedPage++">
            <i class="material-icons">chevron_right</i>
          </li>
        </ul>
      </div>
    </div>
    <div class="row">
      <div class="col s12">
        <div class="divider" style="margin-bottom: 12px"></div>
        <a v-show="AddNewEntry" class="waves-effect waves-light btn" @click="AddNewEntry = !AddNewEntry">Cancel</a>
        <a v-show="AddNewEntry" class="waves-effect waves-light btn" @click="saveNewEntry">Save</a>
        <a v-show="!AddNewEntry" class="waves-effect waves-light btn" @click="AddNewEntry = !AddNewEntry">Add new log</a>
      </div>
    </div>
  </div>
</template>

<script>
import AxleCounterService from '@/services/AxleCounterService'
import moment from 'moment'
// old code
import AxleCounterApi from '../../services/api/axlecounter/AxleCounterApi'
import AuthenticationService from '../../services/AuthenticationService'

export default {
  data () {
    return {
      LogbookItems: [],
      AddNewEntry: false,
      NewEntry: {
        Comment: undefined
      },
      paging: {
        enabled: true,
        itemsPerPage: 15,
        numberOfPages: 0,
        selectedPage: 1,
        chevronLeftActive: false,
        chevronRightActive: false
      },
      maxRows: {
        startFrom: 0,
        nrOfRows: 100
      }
    }
  },
  mounted: function () {
    this.getLogs()
  },
  watch: {
    '$route.params.railobjectid': {
      handler: function (val, oldVal) {
        this.getLogs()
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    getLogs: function () {
      this.LogbookItems = []
      AxleCounterService.GetLogbookByRailobjectId(this.$route.params.railobjectid, this.maxRows.startFrom, this.maxRows.nrOfRows).then(result => {
        this.LogbookItems = result.data
      }).then(() => {
        this.setPagingParameters()
      })
    },
    setPagingParameters: function () {
      this.paging.selectedPage = 1
      this.paging.numberOfPages = Math.ceil(this.LogbookItems.length / this.paging.itemsPerPage)
    },
    saveNewEntry: function () {
      if (this.$route.params.railobjectid) {
      // Old code
        AxleCounterApi.addLogBook({
          railobjectid: this.$route.params.railobjectid,
          comment: this.NewEntry.Comment,
          username: AuthenticationService.getUser().UserName,
          userid: AuthenticationService.getUser().UserId
        }).then(resp => {
          if (resp.status !== 201) {
            alert(this.$t('axelecounter.somethingwentwrong'))
          } else {
            this.$notify({
              group: 'alerts',
              type: 'success',
              title: 'Saving',
              text: 'Succes'
            })
            this.getLogs()
            this.AddNewEntry = false
          }
        })
      }
    },
    commentTypeToText (type) {
      if (type === 1) return 'axlecounter.usercomment'
      if (type === 2) return 'axlecounter.statusWarning'
      if (type === 3) return 'axlecounter.alarm'
      if (type === 4) return 'axlecounter.resetcomment'
      if (type === 5) return 'axlecounter.maintenance'
      if (type === 6) return 'axlecounter.importfailurelogs'
      if (type === 7) return 'axlecounter.importmaintenancelogs'
      if (type === 8) return 'axlecounter.systemcomments'
      else return 'axlecounter.statusUnknown'
    },
    formatDateTime: (dateTime) => {
      return moment(String(dateTime)).format('DD-MM-YYYY HH:mm')
    }
  }
}

</script>

<style scoped>
.logbook-page {
  overflow-y: auto;
  height: 84vh;
}
</style>



// WEBPACK FOOTER //
// src/pages/axlecounter/_logbook.vue